export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-76x76-522fc26df7f129691a65eb1bc1d8d83b.png";